$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import {Navigation,Pagination,Autoplay,} from 'swiper/modules';




gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {


    // --- SHOWHIDE NAVBAR ---

    var didScroll;
    var lastScrollTop = 0;
    var delta = 120;
    var navbarHeight = 110;
    $(window).scroll(function () {
        didScroll = true;
    });
    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 350);
    function hasScrolled() {
        var st = $(this).scrollTop();
        if (Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st > lastScrollTop && st > navbarHeight) {
            $('.nav-sticky').addClass('nav-up');
        } else {
            if (st + $(window).height() < $(document).height()) {
                $('.nav-sticky').removeClass('nav-up');
            }
        }
        lastScrollTop = st;
    }
    
    // --- NAV ---

    
    $(".nav-burger").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    }); 
    
    $(".nav ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-active ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        } 
    });

    $(".nav-responsive ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        var $this = $(this);
        var $parent = $this.parents("li").first();
        
        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-active ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        } 
    });
    
    $(".page-single article .gallery br").remove();  

    // --- BURGER ANIMATED ---
    
    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---
    
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });
    
    $(document.body).trigger('wc_fragment_refresh');


    /*-------- Animation col custom---------*/
    $(".col__custom .title__container .col__action__container .col__action").click(function () {
        var $contentContainer = $(this).closest(".col__custom").find(".content__container");
        $contentContainer.toggleClass("active");
        $(".col__custom .title__container .col__action__container .col__action").not(this).removeClass("active");
      
        $(".col__custom .title__container .col__action__container .col__action").toggleClass("active");
        $(".col__custom .title__container .col__action__container .col__action").not(this).removeClass("active");
      });


     

     /*-------- Swiper section cabinet ---------*/
    
     var swiper = new Swiper(".Swiper__cabinet", {
        modules: [Autoplay,Pagination],
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
      });


       // --- FILTRE PAGE CONSEILS ---


    $('.filter__btn').on('click', function() {
        $('.filter__btn').removeClass('active'); // Supprimer la classe "active" de tous les boutons de filtre
        $(this).addClass('active'); // Ajouter la classe "active" au bouton de filtre cliqué
        var cat = $(this).data('cat');
        if (cat == 'all') {
            $('.conseil').show();
        } else {
            $('.conseil').hide(); // Cacher tous les projets
            $('.conseil[data-cat*="' + cat + '"]').show(); // Afficher les projets qui ont le slug de catégorie dans leurs data-attribute
        }
    });
   


   


    

    
});

    
    

